import React, { useState } from 'react'
import { Download } from 'react-bootstrap-icons'
import { CircularProgress, Popover } from '@mui/material'
import { documentTypeId } from 'Utils/constants'
import { isAllowedCompany } from 'Utils/isAllowedCompany'
import './downloadButton.css'

export const DownloadButton = ({ disabled, download, companyId }) => {
  const [anchorEl, setAnchorEl] = useState(false)
  const [loadingQuote, setLoadingQuote] = useState(false)
  const [loadingOdc, setLoadingOdc] = useState(false)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleDownloadPdf = async docType => {
    await download(false, docType)
    handleClose()
  }

  const handleDownloadDocument = async (docType, setLoader) => {
    try {
      setLoader(true)
      const validationParameterizedFunction = docType
        ? handleDownloadPdf(docType)
        : handleDownloadPdf()

      await validationParameterizedFunction
    } catch (error) {
      console.log('download error: ', error)
    } finally {
      setLoader(false)
    }
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <div>
      <button
        data-testid="btn-download"
        aria-describedby={id}
        onClick={handleClick}
        disabled={disabled}
        style={{
          backgroundColor: disabled ? 'gray' : '#11D29E',
          color: disabled ? 'lightgray' : '#FFFFFF',
        }}>
        <Download />
      </button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}>
        <div className="popover-buttons-wrapper">
          <button
            data-testid="btn-download-quote"
            className={
              loadingQuote
                ? 'popover-content-button-loading'
                : 'popover-content-button'
            }
            disabled={loadingQuote}
            onClick={() => handleDownloadDocument(null, setLoadingQuote)}>
            {loadingQuote ? (
              <CircularProgress
                sx={{
                  '& .MuiCircularProgress-svg': { color: '#FFFFFF' },
                }}
                size={21}
              />
            ) : (
              'Cotización'
            )}
          </button>
          {/* Purchase order generation for Punto Cochez is disabled */}
          {isAllowedCompany(companyId) && (
            <button
              data-testid="btn-download-odc"
              disabled={loadingOdc}
              onClick={() =>
                handleDownloadDocument(documentTypeId.ODC, setLoadingOdc)
              }
              className={
                loadingOdc
                  ? 'popover-content-button-loading'
                  : 'popover-content-button'
              }>
              {loadingOdc ? (
                <CircularProgress
                  sx={{
                    '& .MuiCircularProgress-svg': { color: '#FFFFFF' },
                  }}
                  size={21}
                />
              ) : (
                'Orden de compra'
              )}
            </button>
          )}
        </div>
        <div className="popover-triangle" />
      </Popover>
    </div>
  )
}
